if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      this.form = document.getElementById(this.cartTermsCheckbox.getAttribute('form'));
      this.checkoutButton = this.form.querySelector('button[name="checkout"]');

      this.clickHandler = this.handleBlock.bind(this);
      this.checkoutButton.addEventListener('click', this.clickHandler, true);

      this.submitHandler = this.handleBlock.bind(this);
      this.form.addEventListener('submit', this.submitHandler, true);

      this.changeHandler = this.updateButtonState.bind(this);
      this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
      this.updateButtonState();
    }

    disconnectedCallback() {
      this.checkoutButton.removeEventListener('click', this.clickHandler, true);
      this.form.removeEventListener('submit', this.submitHandler, true);
      this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
    }

    updateButtonState() {
      this.checkoutButton.disabled = !this.cartTermsCheckbox.checked;
    }

    handleBlock(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        alert(theme.strings.cartTermsConfirmation);
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}